import React, { createContext, useContext, useState } from 'react';

// 1. Create the context
const AppContext = createContext();

// fake list of clients, which should be injected, but static for demo purposes
const clients = [
  "AAG - Flynn Applebee's",
  "AARK - Apple Arkansas",
  "ABC - American Bread Company",
  "ACENTRAL - Apple Central",
  "ACGBBQ - Sonnys BBQ",
]
const parsedClients = clients.map((client) => {
  const [initials, name] = client.split(" - ")
  return { initials, name }
})

// 2. Create the provider
export const AppProvider = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState({ client: 'ABC', name: 'American Bread Company' });
  const [clientList] = useState(parsedClients);

  return (
    <AppContext.Provider value={{ clientList, selectedClient, setSelectedClient }}>
      {children}
    </AppContext.Provider>
  );
};

// 3. Create a hook for easier consumption
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
